import { TEquityInfoKS } from '@commenda/types/src/incorporation/types';
import { CorporationType } from '@prisma/client';
import { TShareholderVsSharePercentageMap } from '../../EquityInfo/types';

export const generateOwnershipSummaryTableRowsForUAE = ({
  equityInfo,
  selectedStakeholders,
  corporationType,
}: {
  equityInfo: TEquityInfoKS;
  selectedStakeholders: TShareholderVsSharePercentageMap;
  corporationType: CorporationType;
}) => {
  const ownershipPool = 100;

  let totalOwnership = 0;
  let totalActualOwnership = 0;
  let totalShares = 0;

  const ownershipSummaryTableRows = Object.values(
    selectedStakeholders || {}
  ).map((stakeholder) => {
    const actualOwnership = stakeholder.sharePercentage;
    totalOwnership += stakeholder.sharePercentage || 0;
    totalActualOwnership += actualOwnership;
    totalShares += Math.round((equityInfo.shareCount * actualOwnership) / 100);
    return {
      id:
        stakeholder.type === 'INDIVIDUAL'
          ? `INDIVIDUAL_${stakeholder.id}`
          : `INSTITUTION_${stakeholder.id}`,
      name: stakeholder.name,
      ownership: stakeholder.sharePercentage
        ? stakeholder.sharePercentage.toFixed(2)
        : '',
      actualOwnership: actualOwnership ? actualOwnership.toFixed(2) : '',
      esopContribution: '',
      shares: Math.round(
        (equityInfo.shareCount * actualOwnership) / 100
      ).toLocaleString(),
    };
  });

  ownershipSummaryTableRows.push({
    id: '-2',
    name: 'Total',
    ownership: totalOwnership.toFixed(2),
    actualOwnership: totalActualOwnership.toFixed(2),
    esopContribution: '',
    shares: totalShares.toLocaleString(),
  });

  return ownershipSummaryTableRows;
};
